import React from "react";
import CommonInput from "../../../components/forms/CommonInput";
import CommonInputMask from "../../../components/forms/CommonInputMask";
import {
  handleChange,
  handleChangeUnmask,
} from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";

function ClienteDadosCPF({ valuesHook }) {
  const { values, setValues } = valuesHook;

  return (
    <>
      <div className="row">
        <div className="col-md-3 mb-3">
          <CommonInput
            label="Nome"
            id="razao_social"
            value={values.razao_social}
            onChange={(e) => handleChange(e, values, setValues)}
            required
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonInputMask
            label="CPF"
            id="cnpj"
            value={values.cnpj}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask="999.999.999-99"
            required
            disabled
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonInput
            label="E-mail"
            id="email"
            value={values.email}
            onChange={(e) => handleChange(e, values, setValues)}
            required
            type="email"
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonInputMask
            label="Telefone"
            id="telefone"
            value={values.telefone}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask={"(99)9999-9999"}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 mb-3">
          <CommonInputMask
            label="Celular"
            id="celular"
            value={values.celular}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask={"(99)9 9999-9999"}
          />
        </div>
      </div>
    </>
  );
}

ClienteDadosCPF.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
};

export default ClienteDadosCPF;
